export default "__VITE_ASSET__abd3d6c7__"